<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="750px"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <el-overlay-loading :loading="modalloading" />
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2" v-if="!modalloading">
        <h2>{{ showTitle }}</h2>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <v-card class="mb-2" v-if="modalloading || atnaujintiLoading">
          <v-card-text class="mb-0 pb-0">
            <v-skeleton-loader type="article"></v-skeleton-loader>
          </v-card-text>
        </v-card>
        <v-card class="mb-2" v-if="!modalloading && !atnaujintiLoading">
          <v-card-title class="mt-0 pt-1 pb-1">
            <v-tabs v-model="tab" v-if="!isAsmuo">
              <v-tabs-slider color="primary"></v-tabs-slider>
              <v-tab key="JUR" :disabled="disableTabJUR">
                <h4>Juridinis asmuo</h4>
              </v-tab>
              <v-tab key="FIZ" :disabled="disableTabFIZ">
                <h4>Fizinis asmuo</h4>
              </v-tab>
            </v-tabs>
          </v-card-title>
          <v-card-text class="mb-0 pb-0">
            <template v-if="showAsmuoError">
              <v-row>
                <v-col cols="12">
                  <v-alert dense outlined type="error">
                    <span v-html="errorAsmuoMessage"></span>
                    <router-link
                      v-if="!!errorLinkas"
                      class="linkas"
                      :to="{ name: 'migrisWeb' }"
                      target="_blank"
                      name="linkas"
                    >
                      {{ errorLinkas.text }}
                    </router-link>
                  </v-alert>
                </v-col>
              </v-row>
            </template>
            <v-tabs-items v-model="tab" class="pt-1">
              <v-tab-item key="JUR">
                <v-row v-if="getTipas === 'JUR'">
                  <v-col cols="12" class="my-0 py-0">
                    <el-text-field
                      :required="isRequiredJuridinisKodas"
                      label="Juridinio asmens kodas"
                      :tooltip="juridinisAsmensKodasTooltip"
                      :readonly="isAsmuo"
                      :counter="juridinisKodasLength"
                      v-mask="juridinisKodasMask"
                      v-model="modalAsmuo.asm_asmens_kodas_jur"
                      autofocus
                    />
                  </v-col>
                  <v-col cols="12" class="my-0 py-0">
                    <el-text-field
                      :required="isRequiredJuridinisPavadinimas"
                      label="Pavadinimas"
                      :tooltip="juridinisPavadinimasTooltip"
                      :readonly="isAsmuo"
                      :counter="200"
                      v-model="modalAsmuo.asm_pavadinimas"
                    />
                  </v-col>
                  <v-col cols="12" class="my-0 py-0" v-if="isForeign && false">
                    <el-autocomplete
                      :required="isRequired"
                      :items="salisList"
                      itemvalue="value"
                      itemtext="text"
                      label="Užsienio valstybė"
                      tooltip="Modalas asmuo. Neregistruotas. Užsienio valstybė JUR"
                      :readonly="isAsmuo"
                      v-model="modalAsmuo.asm_vls_kodas"
                    />
                  </v-col>
                </v-row>
                <!-- </template> -->
              </v-tab-item>
              <v-tab-item key="FIZ">
                <v-row v-if="getTipas === 'FIZ'">
                  <v-col cols="12" v-if="showForeignKodoTipas">
                    <span class="bold-label"
                      >{{ $t('Kodo tipas') }}
                      <el-need v-if="!isAsmuo" /><el-tooltip
                        inline
                        tooltip="Modalas asmuo. Kodo tipas"
                      />
                    </span>
                    <el-radio-group
                      inline
                      class="mt-0 mb-2"
                      :required="isRequired"
                      :items="filteredForeignKodoTipas"
                      :readonly="isAsmuo"
                      v-model="modalAsmuo.asm_kodo_tipas"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    class="my-0 py-0"
                    sm="6"
                    v-if="showForeignGimimoData"
                  >
                    <el-date-picker
                      :required="isRequired"
                      label="Gimimo data"
                      tooltip="Modalas asmuo. Neregistruotas. Gimimo data"
                      :readonly="isAsmuo"
                      v-model="modalAsmuo.asm_gimimo_data"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    class="my-0 py-0"
                    sm="6"
                    v-if="showForeignGimimoData"
                  >
                    <el-autocomplete
                      :required="isRequired"
                      :items="salisList"
                      itemvalue="value"
                      itemtext="text"
                      label="Pilietybė"
                      tooltip="Modalas asmuo. Neregistruotas. Pilietybė FIZ"
                      :readonly="isAsmuo"
                      v-model="modalAsmuo.asm_vls_kodas"
                    />
                  </v-col>
                  <v-col cols="12" class="my-0 py-0" v-if="showFizinisKodas">
                    <el-text-field
                      key="FIZ_kodas"
                      :required="isRequired"
                      label="Asmens kodas"
                      tooltip="Modalas asmuo. Asmens kodas"
                      :readonly="isAsmuo"
                      v-mask="fizinisKodasMask"
                      v-model="modalAsmuo.asm_asmens_kodas_fiz"
                      :autofocus="!isForeign && !isAsmuo"
                    />
                  </v-col>
                  <v-col cols="12" class="my-0 py-0">
                    <el-text-field
                      :required="isRequiredFizinisVardas"
                      label="Vardas"
                      key="FIZ_vardas"
                      :tooltip="fizinisVardasTooltip"
                      :readonly="isAsmuo"
                      :counter="60"
                      v-model="modalAsmuo.asm_fiz_vardas"
                      :autofocus="isForeign && !isAsmuo"
                    />
                  </v-col>
                  <v-col cols="12" class="my-0 py-0">
                    <el-text-field
                      :required="isRequiredFizinisPavarde"
                      label="Pavardė"
                      key="FIZ_pavarde"
                      :tooltip="fizinisPavardeTooltip"
                      :readonly="isAsmuo"
                      :counter="60"
                      v-model="modalAsmuo.asm_fiz_pavarde"
                    />
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
            <template v-if="showAsmenysList">
              <template v-if="showAsmuoWarning">
                <v-row>
                  <v-col cols="12">
                    <v-alert dense outlined type="warning" class="ispejimas">
                      <span v-html="warningAsmuoMessage"></span>
                    </v-alert>
                  </v-col>
                </v-row>
              </template>

              <el-asmenys-list
                v-if="!isTipasFIZ"
                :asmenys="asmenysList"
                :tipas="getTipas"
                @selectAsmuo="selectAsmuo"
              />
              <el-asmenys-migris-list
                v-if="isTipasFIZ"
                :asmenys="asmenysList"
                :tipas="getTipas"
                @selectAsmuo="selectAsmuoMigris"
              />
            </template>
            <v-row class="pb-2">
              <v-col
                cols="12"
                class="my-0 py-0"
                v-if="isAsmuo && skolininkas && !isSavitarna"
              >
                <el-checkbox
                  label="Skolininkas yra turto(-ų) savininkas"
                  tooltip="Modalas asmuo. Skolininkas yra savininkas"
                  :readonly="readonly || tikAdresas"
                  v-model="modalAsmuo.sasm_skolininkas_savininkas"
                />
              </v-col>
              <v-col cols="12" class="mb-2" v-if="isAsmuo && kreditorius">
                <el-checkbox
                  label="Kreditorių atstovas"
                  tooltip="Modalas asmuo. Kreditorių atstovas"
                  :readonly="readonly || tikAdresas"
                  v-model="modalAsmuo.sasm_kreditorius_atstovas"
                />
              </v-col>
              <v-col cols="12" v-if="modalAsmuo.sasm_kreditorius_atstovas">
                <el-autocomplete
                  need
                  label="Kreditorių atstovavimo pagrindas"
                  tooltip="Modalas asmuo. Kreditorių atstovavimo pagrindas"
                  :readonly="readonly || tikAdresas"
                  :items="atstovavimoPagrindas"
                  itemvalue="value"
                  itemtext="text"
                  v-model="modalAsmuo.sasm_atstovavimo_pagrindas_kla_id"
                />
              </v-col>
              <v-col cols="12" class="mb-2" v-if="isAsmuo && isSutartis">
                <span class="label text-inline"
                  >Sutarties šalis<el-need :need="isNeed" v-if="!readonly"
                /></span>
                <el-radio-group
                  inline
                  required
                  label="Sutarties šalis"
                  :items="sutartisRoleList"
                  :readonly="readonly || tikAdresas"
                  v-model="modalAsmuo.sasm_role_objekte"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions v-if="!isAsmuo">
            <el-switch
              v-if="showForeignSwitch"
              :label="asmuoNeregistruotasTitle"
              :tooltip="asmuoNeregistruotasTooltip"
              :readonly="isAsmuo"
              v-model="modalAsmuo.foreign"
            />
            <v-spacer></v-spacer>
            <el-button
              v-if="showAsmuoSave"
              @click.native="saveRegistras()"
              :loading="loadingRegistras"
              :disabled="disabledIeskoti"
            >
              Saugoti registre
            </el-button>
            <el-button
              primary
              @click.native="checkRegistras()"
              :loading="loadingRegistras"
              :disabled="disabledIeskoti"
            >
              Tikrinti registre
            </el-button>
          </v-card-actions>
        </v-card>

        <v-card class="mb-3" v-if="showDokumentaiList">
          <v-card-text class="mb-0 pb-0">
            <v-tabs v-model="dokumentaiTab" class="mb-3">
              <v-tabs-slider color="primary"></v-tabs-slider>
              <v-tab class="dokumentai-tab" v-if="this.showAsmuoAdresas">
                <h4>Adresas</h4>
              </v-tab>
              <v-tab class="dokumentai-tab" v-if="this.showAsmuoDokumentas">
                <h4>Asmens dokumentas</h4>
              </v-tab>
              <v-tab class="dokumentai-tab" v-if="this.showVeikiantisPagal">
                <h4>Veikiantis pagal</h4>
              </v-tab>
              <v-tab class="dokumentai-tab" v-if="this.showTpDalis">
                <h4>TP Dalis</h4>
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="dokumentaiTab" v-if="showDokumentaiList">
              <v-tab-item v-if="this.showAsmuoAdresas">
                <el-asmuo-adresas
                  :readonly="readonly"
                  :foreign="isForeign"
                  :fizinis="isFizinis"
                  :dubliu-skaicius="modalAsmuo.dubliu_skaicius"
                  v-model="modalAsmuo.adresas"
                  v-if="
                    isAsmuo && !informuojamas && !ntrSearch && !perleidziaTeise
                  "
                  autofocus
                />
              </v-tab-item>
              <v-tab-item v-if="this.showAsmuoDokumentas">
                <el-asmuo-dokumentas
                  :key="asmuoDokumentasKey"
                  :readonly="readonly"
                  :asm-kodas="modalAsmuo.asm_asmens_kodas"
                  :foreign="isForeign"
                  v-model="modalAsmuo.sasm_fiz_dok_info"
                  @disableSave="disableSave"
                />
              </v-tab-item>
              <v-tab-item v-if="this.showVeikiantisPagal">
                <el-veikiantis-pagal
                  :key="veikiantisPagalKey"
                  :readonly="readonly"
                  :foreign="isForeign"
                  :asm-kodas="modalAsmuo.asm_asmens_kodas"
                  v-model="modalAsmuo.sasm_veikiantis_pagal"
                  @disableSave="disableSave"
                />
              </v-tab-item>
              <v-tab-item v-if="this.showTpDalis">
                <v-row>
                  <v-col cols="12" md="6" class="my-3">
                    <el-text-field
                      label="Transporto priemonės dalis"
                      tooltip="Modalas asmuo. Transporto priemonės dalis"
                      :placeholder="tpDalisPlaceholder"
                      v-mask="tpDalisMask"
                      :readonly="readonly"
                      :counter="20"
                      v-model="modalAsmuo.sasm_dalis"
                      autofocus
                    />
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>

        <el-asmuo-pastas
          :key="asmuoPastasKey"
          v-model="modalAsmuo.sasm_el_pastas"
          v-if="isAsmuo && informuojamas"
          :readonly="readonly"
          autofocus
        />
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <el-button
          v-if="showAtnaujinti"
          @click.native.stop="atnaujintiAsmuo()"
          :loading="atnaujintiLoading"
        >
          Atnaujinti
        </el-button>
        <v-spacer></v-spacer>
        <el-button @click.native.stop="closeModal()">
          Atšaukti
        </el-button>
        <el-button
          primary
          :loading="saveLoading"
          @click.native="saveData()"
          v-if="isAsmuo && !readonly"
        >
          Saugoti
        </el-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '../../mixins/userRole'
import HipotekaMap from '../hipoteka/hipotekaMap'
import { tpDalisMaskFilter } from '../../mixins/tpDalisMask'

export default {
  name: 'ModalAsmuo',
  mixins: [userRole],
  props: {
    asmuoRole: String,
    title: String,
    value: Boolean,
    asmuo: Object,
    salys: Array,
    atstovavimoPagrindas: Array,
    readonly: Boolean,
    parentAtstovasId: Number,
    perleidimas: Boolean,
    atnaujinti: Boolean,
    tikAdresas: Boolean,
    ktp: Boolean,
  },
  data() {
    return {
      loading: true,
      loadingRegistras: false,
      modalAsmuo: {
        asm_asmens_kodas_jur: null,
        asm_pavadinimas: null,
        asm_asmens_kodas_fiz: null,
        asm_fiz_vardas: null,
        asm_fiz_pavarde: null,
        asm_gimimo_data: null,
        asm_vls_kodas: null,
      },
      asmenysList: [],
      showAsmenysList: false,
      showAsmuoError: false,
      errorAsmuoMessage: null,
      showAsmuoWarning: false,
      warningAsmuoMessage: null,
      showAsmuoSave: false,
      modalloading: true,
      atnaujintiLoading: false,
      tab: 0,
      saveLoading: false,
      dokumentaiTab: 0,
      preventSave: false,
      tpDalisPlaceholder: '#/###',
      tpDalisMask: tpDalisMaskFilter,
      errorLinkasTag: 'ASMENS_IVEDIMAS',
    }
  },
  $_veeValidate: {
    validator: 'new',
  },
  computed: {
    ...mapGetters([
      'objektasID',
      'hipotekaTipas',
      'objektasVeiksmas',
      'appSavitarna',
      'perduodamasKreditoriui',
    ]),
    showTitle() {
      if (this.title) {
        return this.title
      } else {
        if (this.isAsmuo) {
          if (this.isFizinis) {
            return 'Fizinis asmuo'
          } else {
            return 'Juridinis asmuo'
          }
        } else {
          return 'Naujas asmuo'
        }
      }
    },
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    isSutartis() {
      return this.asmuoRole === HipotekaMap['asmenysRoles'].sutartis
    },
    sutartisRoleList() {
      return [
        {
          label: this.sutartisDavejasText,
          tooltip: `Modalas asmuo. Sutarties šalis. ${this.sutartisDavejasTooltip}`,
          value: 'sutartis_davejas',
        },
        {
          label: this.sutartisGavejasText,
          tooltip: `Modalas asmuo. Sutarties šalis. ${this.sutartisGavejasTooltip}`,
          value: 'sutartis_gavejas',
        },
      ]
    },
    sutartisDavejasText() {
      const key = Object.keys(HipotekaMap['sutartisRolesTekstas']).find(e =>
        this.hipotekaTipas.includes(e)
      )
      return key
        ? HipotekaMap['sutartisRolesTekstas'][key].sutartis_davejas
        : null
    },
    sutartisDavejasTooltip() {
      const key = Object.keys(HipotekaMap['sutartisRolesTekstas']).find(e =>
        this.hipotekaTipas.includes(e)
      )
      return key
        ? HipotekaMap['sutartisRolesTekstas'][key].sutartis_davejasTooltip
        : null
    },
    sutartisGavejasText() {
      const key = Object.keys(HipotekaMap['sutartisRolesTekstas']).find(e =>
        this.hipotekaTipas.includes(e)
      )
      return key
        ? HipotekaMap['sutartisRolesTekstas'][key].sutartis_gavejas
        : null
    },
    sutartisGavejasTooltip() {
      const key = Object.keys(HipotekaMap['sutartisRolesTekstas']).find(e =>
        this.hipotekaTipas.includes(e)
      )
      return key
        ? HipotekaMap['sutartisRolesTekstas'][key].sutartis_gavejasTooltip
        : null
    },
    showForeignSwitch() {
      return (
        this.isTipasJUR ||
        (this.isTipasFIZ && (!this.isSavitarna || this.objektasVeiksmas !== 1))
      )
    },
    compAsmuoRole() {
      if (this.isSutartis) {
        return this.modalAsmuo.sasm_role_objekte
      } else {
        return this.asmuoRole
      }
    },
    asmuoPastasKey() {
      return 'pastas' + this.modalAsmuo.sasm_id
    },
    asmuoDokumentasKey() {
      return 'dokumentas' + this.modalAsmuo.sasm_id
    },
    veikiantisPagalKey() {
      return 'veikiantisPagal' + this.modalAsmuo.sasm_id
    },
    isAsmuo() {
      return this.modalAsmuo && this.modalAsmuo.amn_id > 0
    },
    isForeign() {
      return (this.modalAsmuo && this.modalAsmuo.foreign) ?? false
    },
    isFizinis() {
      return (this.modalAsmuo && this.modalAsmuo.tipas === 'FIZ') ?? false
    },
    disabledIeskoti() {
      return false
    },
    getTipas() {
      return this.tab === 0 ? 'JUR' : 'FIZ'
    },
    isTipasFIZ() {
      return this.getTipas === 'FIZ'
    },
    isTipasJUR() {
      return this.getTipas === 'JUR'
    },
    salisList() {
      return this.salys
    },
    skolininkas() {
      return this.compAsmuoRole === HipotekaMap['asmenysRoles'].skolininkas
    },
    kreditorius() {
      return this.compAsmuoRole === HipotekaMap['asmenysRoles'].kreditorius
    },
    informuojamas() {
      return this.compAsmuoRole === HipotekaMap['asmenysRoles'].informuojamas
    },
    atstovas() {
      return this.compAsmuoRole === HipotekaMap['asmenysRoles'].atstovas
    },
    perleidziaTeise() {
      return this.compAsmuoRole === HipotekaMap['asmenysRoles'].perleidzia
    },
    priimaTeise() {
      return this.compAsmuoRole === HipotekaMap['asmenysRoles'].priima
    },
    isNeed() {
      return !this.isAsmuo
    },
    isRequired() {
      return !this.isAsmuo
    },
    isRequiredJuridinisKodas() {
      return this.isRequired && !this.modalAsmuo.asm_pavadinimas
    },
    juridinisKodasLength() {
      return this.isForeign ? 20 : 9
    },
    juridinisKodasMask() {
      let mask = 'X'
      return mask.repeat(this.juridinisKodasLength)
    },
    fizinisKodasMask() {
      let mask = '#'
      let fizinisKodasLength = 11

      if (this.modalAsmuo.asm_kodo_tipas === 'eidas') {
        mask = 'X'
        fizinisKodasLength = 50
      }
      return mask.repeat(fizinisKodasLength)
    },
    isRequiredJuridinisPavadinimas() {
      return this.isRequired && !this.modalAsmuo.asm_asmens_kodas_jur
    },
    isRequiredFizinisVardas() {
      return (
        this.isRequired &&
        (this.isForeign ||
          !this.roleOr([
            'DT_notaras',
            'DT_notaro_padejejas',
            'DT_notaro_atstovas',
            'DT_teismas',
            'DT_antstolis',
            'DT_kita_institucija',
            'RG_STSR_registrat',
            'RG_NTR_registrat',
            'RG_NTR_vadovas',
          ]))
      )
    },
    isRequiredFizinisPavarde() {
      return (
        this.isRequired &&
        (this.isForeign ||
          !this.roleOr([
            'DT_notaras',
            'DT_notaro_padejejas',
            'DT_notaro_atstovas',
            'DT_teismas',
            'DT_antstolis',
            'DT_kita_institucija',
            'RG_STSR_registrat',
            'RG_NTR_registrat',
            'RG_NTR_vadovas',
          ]))
      )
    },
    juridinisAsmensKodasTooltip() {
      return this.isForeign
        ? 'Modalas asmuo. Neregistruotas. Juridinio asmens kodas'
        : 'Modalas asmuo. Juridinio asmens kodas'
    },
    juridinisPavadinimasTooltip() {
      return this.isForeign
        ? 'Modalas asmuo. Neregistruotas. Pavadinimas'
        : 'Modalas asmuo. Pavadinimas'
    },
    fizinisVardasTooltip() {
      return this.isForeign
        ? 'Modalas asmuo. Neregistruotas. Vardas'
        : 'Modalas asmuo. Vardas'
    },
    fizinisPavardeTooltip() {
      return this.isForeign
        ? 'Modalas asmuo. Neregistruotas. Pavardė'
        : 'Modalas asmuo. Pavardė'
    },
    asmuoNeregistruotasTitle() {
      return this.getTipas === 'JUR'
        ? 'Asmuo neregistruotas Juridinių asmenų registre'
        : 'Asmuo neregistruotas LR gyventojų registre'
    },
    asmuoNeregistruotasTooltip() {
      return this.getTipas === 'JUR'
        ? this.asmuoNeregistruotasTooltipJUR
        : 'Modalas asmuo. Asmuo neregistruotas FIZ'
    },
    asmuoNeregistruotasTooltipJUR() {
      return this.isSavitarna && this.objektasVeiksmas === 1
        ? 'Modalas asmuo. Asmuo neregistruotas JUR. Savitarna. Sudarymas'
        : 'Modalas asmuo. Asmuo neregistruotas JUR'
    },
    ntrSearch() {
      return this.compAsmuoRole === 'ntr-search'
    },
    compForeign() {
      return this.modalAsmuo.foreign
    },
    isSavitarna() {
      return this.appSavitarna
    },
    disableTabJUR() {
      return this.atstovas
    },
    disableTabFIZ() {
      return (
        this.role('EL_JA') &&
        this.perduodamasKreditoriui != 1 &&
        !this.isSutartis
      )
    },
    errorMessageForeignJUR() {
      return (
        'Juridinis asmuo užsienietis pagal įvestus kriterijus nerastas. <br>' +
        'Norėdami, kad juridinis asmuo būtų įregistruotas RC, kreipkitės el. paštu info@registrucentras.lt laiško antraštėje nurodydami - JA asmens užsieniečio įvedimas. <br>' +
        'Laiško tekste privalomus parametrus: pavadinimą, užsienio valstybę. Papildomus neprivalomus parametrus: asmens kodą (jei turi), adresą, registracijos datą.'
      )
    },
    showAtnaujinti() {
      return (
        this.atnaujinti &&
        this.isAsmuo &&
        this.asmuo.sasm_id > 0 &&
        !this.readonly
      )
    },
    showAsmuoAdresas() {
      return !this.atstovas
    },
    showAsmuoDokumentas() {
      return (
        this.objektasVeiksmas === 1 &&
        this.isFizinis &&
        // !this.isForeign &&
        (this.modalAsmuo.sasm_fiz_dok_info ||
          (!this.readonly &&
            this.roleOr([
              'DT_notaras',
              'DT_notaro_padejejas',
              'DT_notaro_atstovas',
            ])))
      )
    },
    showVeikiantisPagal() {
      return (
        this.objektasVeiksmas === 1 &&
        this.isFizinis &&
        //!this.isForeign &&
        this.atstovas &&
        (this.modalAsmuo.sasm_veikiantis_pagal ||
          (!this.readonly &&
            this.roleOr([
              'DT_notaras',
              'DT_notaro_padejejas',
              'DT_notaro_atstovas',
            ])))
      )
    },
    showTpDalis() {
      return this.isKtp
    },
    showDokumentaiList() {
      return (
        this.isAsmuo &&
        !this.informuojamas &&
        (this.showAsmuoAdresas ||
          this.showAsmuoDokumentas ||
          this.showVeikiantisPagal ||
          this.showTpDalis)
      )
    },
    isKtp() {
      return this.ktp && !this.atstovas
    },
    foreignKodoTipas() {
      return [
        {
          label: this.$t('ILTU'),
          value: 'iltu',
        },
        {
          label: this.$t('eIDAS'),
          value: 'eidas',
          hide: !this.showEidasKodas,
        },
        {
          label: this.$t('Gimimo data'),
          value: 'data',
        },
      ]
    },
    filteredForeignKodoTipas() {
      return this.foreignKodoTipas.filter(item => {
        return !item.hide
      })
    },
    showEidasKodas() {
      return (
        this.isForeign &&
        this.isAsmuo &&
        this.modalAsmuo.asm_kodo_tipas === 'eidas'
      )
    },
    showForeignKodoTipas() {
      return this.isForeign
    },
    showForeignGimimoData() {
      return this.isForeign && this.modalAsmuo.asm_kodo_tipas === 'data'
    },
    showFizinisKodas() {
      if (!this.isForeign) {
        return true
      }
      return this.isForeign && this.modalAsmuo.asm_kodo_tipas !== 'data'
    },
  },
  created() {
    this.modalloading = true
    if (this.asmuo.sasm_id > 0) {
      this.modalAsmuo = {}
      this.getAsmuo(this.asmuo.sasm_id)
    } else {
      if (this.perleidimas) {
        this.modalAsmuo = this.asmuo
      }
      this.modalloading = false
    }
    if (this.atstovas) {
      this.tab = 1
    }
  },
  watch: {
    tab(val) {
      if (!this.isAsmuo) {
        this.modalAsmuo.asm_asmens_kodas_jur = null
        this.modalAsmuo.asm_asmens_kodas_fiz = null
      }
      this.showAsmenysList = false
      if (val === 1 && !this.showForeignSwitch) {
        // this.modalAsmuo.foreign = false
      }
      this.resetError()
    },
    compForeign() {
      this.showAsmenysList = false
      this.resetError()
    },
    filteredForeignKodoTipas(val) {
      if (!this.isAsmuo & this.isForeign && val.length === 1) {
        this.modalAsmuo.asm_kodo_tipas = val[0].value
      }
    },
  },
  methods: {
    resetError() {
      this.errorAsmuoMessage = null
      this.showAsmuoError = false
      this.warningAsmuoMessage = null
      this.showAsmuoWarning = false
      this.showAsmuoSave = false
      this.$validator.reset()
      // this.$nextTick(() => this.$validator.reset())
    },
    getAsmuo(sasm_id) {
      this.$axios
        .get(`asmuo/${sasm_id}`)
        .then(res => {
          this.modalAsmuo = res.data.asmuo
          this.modalAsmuo.asm_asmens_kodas_jur = this.modalAsmuo.asm_asmens_kodas
          this.modalAsmuo.asm_asmens_kodas_fiz = this.modalAsmuo.asm_asmens_kodas
          this.tab = this.isFizinis ? 1 : 0
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.modalloading = false
        })
    },
    atnaujintiAsmuo() {
      this.atnaujintiLoading = true
      this.$axios
        .post(`asmuo/${this.asmuo.sasm_id}/atnaujinimas`)
        .then(res => {
          this.modalAsmuo = res.data.asmuo
          this.modalAsmuo.asm_asmens_kodas_jur = this.modalAsmuo.asm_asmens_kodas
          this.modalAsmuo.asm_asmens_kodas_fiz = this.modalAsmuo.asm_asmens_kodas
          this.tab = this.isFizinis ? 1 : 0
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.atnaujintiLoading = false
        })
    },
    checkRegistras() {
      this.$validator.validateAll().then(res => {
        if (!res) {
          window._VMA.$emit('FORMAT_ERROR')
          return
        }

        this.loadingRegistras = true
        this.showAsmuoError = false
        this.errorAsmuoMessage = null
        this.warningAsmuoMessage = null
        this.showAsmuoWarning = false
        this.showAsmuoSave = false
        this.showAsmenysList = false

        let data = {
          asm_asmens_kodas: null,
          asm_pavadinimas: null,
          asm_gimimo_data: null,
          asm_vls_kodas: null,
          tipas: null,
          asm_fiz_vardas: null,
          asm_fiz_pavarde: null,
          foreign: null,
          asm_kodo_tipas: null,
          obj_id: null,
        }

        data.obj_id = this.objektasID
        data.tipas = this.getTipas
        data.foreign = this.isForeign
        if (this.isTipasFIZ) {
          data.asm_fiz_vardas = this.modalAsmuo.asm_fiz_vardas
          data.asm_fiz_pavarde = this.modalAsmuo.asm_fiz_pavarde
          data.asm_asmens_kodas = this.modalAsmuo.asm_asmens_kodas_fiz

          if (this.isForeign) {
            data.asm_kodo_tipas = this.modalAsmuo.asm_kodo_tipas
            if (this.showForeignGimimoData) {
              data.asm_gimimo_data = this.modalAsmuo.asm_gimimo_data
              data.asm_vls_kodas = this.modalAsmuo.asm_vls_kodas
              data.asm_asmens_kodas = null
            }
          }
        }
        if (this.isTipasJUR) {
          data.asm_asmens_kodas = this.modalAsmuo.asm_asmens_kodas_jur
          data.asm_pavadinimas = this.modalAsmuo.asm_pavadinimas
        }

        this.$axios
          .post('asmuo/search', data)
          .then(res => {
            if (res.data.asmenys.length === 1 && !res.data.forceList) {
              this.selectAsmuo(res.data.asmenys[0])
            } else {
              this.asmenysList = res.data.asmenys
              this.showAsmenysList = true
            }
            this.resetError()

            if (res.data.warning) {
              this.warningAsmuoMessage = res.data.warning
              this.showAsmuoWarning = true
            }
          })
          .catch(err => {
            if (err.response.status === 404) {
              this.errorAsmuoMessage = err.response.data.message
              this.showAsmuoError = true
              if (this.getTipas === 'JUR' && this.isForeign) {
                this.errorAsmuoMessage = this.errorMessageForeignJUR
              }
              this.errorLinkas = this.parseErrorLinkas(this.errorAsmuoMessage)
              this.errorAsmuoMessage = this.cleanErrorMessage(
                this.errorAsmuoMessage
              )
            } else {
              window._VMA.$emit('DATA_ERROR', err.response.data.message)
            }
          })
          .finally(() => {
            this.loadingRegistras = false
            this.modalloading = false
          })
      })
    },
    parseErrorLinkas(message) {
      let linkas = null

      if (message.includes(`<${this.errorLinkasTag}>`)) {
        linkas = {
          value: this.errorLinkasTag,
          text: '"Užsienio fizinių asmenų aplikacijoje"',
        }
      }

      return linkas
    },
    cleanErrorMessage(message) {
      return message.replace(`<${this.errorLinkasTag}>`, '')
    },
    saveRegistras() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.loadingRegistras = true
          this.showAsmuoError = false
          this.errorAsmuoMessage = null
          this.warningAsmuoMessage = null
          this.showAsmuoWarning = false

          const data = {
            asm_fiz_vardas: this.modalAsmuo.asm_fiz_vardas,
            asm_fiz_pavarde: this.modalAsmuo.asm_fiz_pavarde,
            asm_gimimo_data: this.modalAsmuo.asm_gimimo_data,
            asm_vls_kodas: this.modalAsmuo.asm_vls_kodas,
          }

          this.$axios
            .post('asmuo/ikelti', data)
            .then(res => {
              if (res.data.asmenys.length === 1) {
                this.selectAsmuo(res.data.asmenys[0])
              } else {
                this.asmenysList = res.data.asmenys
                this.showAsmenysList = true
              }
              this.resetError()
            })
            .catch(err => {
              if (err.response.status === 404) {
                this.errorAsmuoMessage = err.response.data.message
                this.showAsmuoError = true
              } else {
                window._VMA.$emit('DATA_ERROR', err.response.data.message)
              }
            })
            .finally(() => {
              this.loadingRegistras = false
              this.modalloading = false
            })
        } else {
          window._VMA.$emit('FORMAT_ERROR')
        }
      })
    },
    selectAsmuo(asmuo) {
      this.modalAsmuo = asmuo
      this.modalAsmuo.asm_asmens_kodas_jur = this.modalAsmuo.asm_asmens_kodas
      this.modalAsmuo.asm_asmens_kodas_fiz = this.modalAsmuo.asm_asmens_kodas
      this.modalAsmuo.sasm_atpirkimo_pageidavimas = false
      this.modalAsmuo.parent_atstovas_id = this.parentAtstovasId
      this.tab = this.isFizinis ? 1 : 0
      this.showAsmenysList = false
    },
    selectAsmuoMigris(asmuo) {
      this.showAsmenysList = false

      this.loadingRegistras = true
      this.showAsmuoError = false
      this.errorAsmuoMessage = null
      this.warningAsmuoMessage = null
      this.showAsmuoWarning = false
      this.showAsmuoSave = false
      this.showAsmenysList = false

      let data = {
        asm_asmens_kodas: asmuo.migris_details.iltuCode,
        asm_pavadinimas: null,
        asm_gimimo_data: null,
        asm_vls_kodas: null,
        tipas: asmuo.tipas,
        asm_fiz_vardas: asmuo.asm_fiz_vardas,
        asm_fiz_pavarde: asmuo.asm_fiz_pavarde,
        foreign: asmuo.foreign,
        asm_kodo_tipas: 'iltu',
      }

      this.$axios
        .post('asmuo/search', data)
        .then(res => {
          this.selectAsmuo(res.data.asmenys[0])
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.errorAsmuoMessage = err.response.data.message
            this.showAsmuoError = true

            this.errorLinkas = this.parseErrorLinkas(this.errorAsmuoMessage)
            this.errorAsmuoMessage = this.cleanErrorMessage(
              this.errorAsmuoMessage
            )
          } else {
            window._VMA.$emit('DATA_ERROR', err.response.data.message)
          }
        })
        .finally(() => {
          this.loadingRegistras = false
          this.modalloading = false
        })
    },
    saveData() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.saveLoading = true
          if (this.atstovas) {
            this.modalAsmuo.parent_atstovas_id = this.parentAtstovasId
            this.$emit('savedAtstovas', this.modalAsmuo)
          } else {
            this.$emit('savedData', this.modalAsmuo)
          }
        } else {
          window._VMA.$emit('FORMAT_ERROR')
        }
      })
    },
    closeModal() {
      this.showModal = false
      if (!this.isAsmuo) {
        this.modalAsmuo = {}
        this.showAsmuoError = false
        this.showAsmuoWarning = false
      }
    },
    submit() {
      if (this.readonly || this.preventSave) {
        return
      }
      if (this.isAsmuo) {
        this.saveData()
      } else {
        this.checkRegistras()
      }
    },
    cancel() {
      this.closeModal()
    },
    disableSave(status) {
      this.preventSave = status
    },
  },
}
</script>
<style lang="scss" scoped>
.modalCard {
  background: #f5f5f5 !important;
}
.modalTitle {
  background: #f5f5f5 !important;
  position: sticky;
  top: 0;
  z-index: 2;
  background: none;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.modalActions {
  position: sticky;
  bottom: 0;
  z-index: 1;
}
.label {
  font-size: 13px;
  font-weight: 600;
}
.dokumentai-tab {
  h4 {
    font-size: 0.9rem;
  }
}
.linkas {
  color: rgb(255, 82, 82);
  font-weight: 400;
  text-decoration: underline;
  cursor: pointer;
}
.ispejimas {
  color: #e4800d !important;
}
</style>
